import { render, staticRenderFns } from "./overviewInfo.vue?vue&type=template&id=2bfcec7c&scoped=true&"
import script from "./overviewInfo.vue?vue&type=script&lang=js&"
export * from "./overviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./overviewInfo.vue?vue&type=style&index=0&id=2bfcec7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfcec7c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfcec7c')) {
      api.createRecord('2bfcec7c', component.options)
    } else {
      api.reload('2bfcec7c', component.options)
    }
    module.hot.accept("./overviewInfo.vue?vue&type=template&id=2bfcec7c&scoped=true&", function () {
      api.rerender('2bfcec7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale-nc/detail/components/overviewInfo.vue"
export default component.exports